export class ConfigurationModel {
    useResults: boolean;
}
